import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useConversation, useConversationDetails } from '@app/hooks'

import { closeConversationAndNavigateToMessages } from '@app/utils'

import { Avatar, Icon, ListingPicture } from '@lib/components'

import styles from './styles.module.scss'
import { HeaderProps } from './types'

export const Header = ({ callbackFn }: Readonly<HeaderProps>) => {
  const conversation = useConversation()
  const navigate = useNavigate()

  const { t } = useTranslation()
  const {
    avatar,
    fullName,
    imageUrl,
    shouldUseLogoTemplate,
  } = useConversationDetails(conversation)

  const handleBackToListClick = () => {
    closeConversationAndNavigateToMessages(navigate)
  }

  const avatarComponent = useMemo(() => {
    if (!imageUrl) {
      return (
        <Avatar
          avatar={avatar}
          fullName={fullName}
          size="medium"
          template={shouldUseLogoTemplate ? 'logo-md' : 'user-sm'}
        />
      )
    }

    return <ListingPicture url={imageUrl} alt={fullName} />
  }, [imageUrl, fullName, avatar, shouldUseLogoTemplate])

  return (
    <div className={styles.topblock}>
      <div className={styles.back} onClick={handleBackToListClick}>
        <Icon path="icons/icon-back" />
      </div>
      <div className={styles.avatar}>{avatarComponent}</div>
      <div className={styles.fullName}>{fullName}</div>
      <button
        type="button"
        onClick={callbackFn}
        className={styles.button_details}
      >
        {t('Chat.Sidebar.Title')}
      </button>
    </div>
  )
}
